module.exports = __webpack_public_path__ + "static/media/GM.04f6459c.webp";